import React, { useEffect } from "react";
import moment from "moment";
import { GeneralTable } from "../GeneralComponents/GeneralTable";
import { PopoverButton, useModalAlert } from "../GeneralComponents";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  centeredCell: {
    display: "flex",
    alignItems: "center",
    whiteSpace: "pre-wrap",
    overflow: "hidden", // Hides overflow if it's on one line
    textOverflow: "ellipsis", // Adds '...' if the text is truncated
    lineHeight: "normal", // Ensure standard line height
  },
});

export function DocumentarySubseries() {
  const classes = useStyles();
  const [subserie, setSubserie] = React.useState(null);
  const [subseries, setSubseries] = React.useState([]);
  const [listSeries, setListSeries] = React.useState([]);
  const [listTipoSoporte, setListTipoSoportes] = React.useState([]);
  const [listDisposicionFinal, setDisposicionFinal] = React.useState([]);
  const { showModalAlert } = useModalAlert();
  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(5);
  const [rowCount, setRowCount] = React.useState(0);

  useEffect(() => {
    loadSeries();
    loadTipoSoporte();
    loadDisposicionFinal();
  }, []);

  useEffect(() => {
    loadSubseries();
  }, [page, pageSize]);

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handlePageSizeChange = (pageSize) => {
    setPageSize(pageSize);
  };

  const columns = [
    {
      field: "codigo",
      headerName: "CÓDIGO",
      flex: 0.8,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: "descripcion",
      headerName: "NOMBRE DE LA SUBSERIE",
      type: "string",
      flex: 4,
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <div className={classes.centeredCell} style={{ width: "100%" }}>
          {params.value}
        </div>
      ),
    },
    {
      field: "descripcion_serie",
      headerName: "SERIE",
      type: "string",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      valueGetter: (params) => {
        const match = listSeries.find(
          (s) => String(s.value) === String(params.value)
        );
        return match ? match.label : params.value ?? "No aplica";
      },
    },
    {
      field: "descripcion_disposicion_final",
      headerName: "DISPOSICIÓN FINAL",
      type: "string",
      flex: 1.3,
      disableColumnMenu: true,
      sortable: false,
      valueGetter: (params) => {
        const match = listDisposicionFinal.find(
          (s) => String(s.value) === String(params.value)
        );
        return match ? match.label : params.value ?? "No aplica";
      },
    },
    {
      field: "procedimiento",
      headerName: "PROCEDIMIENTO",
      type: "string",
      flex: 1.5,
      disableColumnMenu: true,
      sortable: false,
      align: "left",
      renderCell: (params) => {
        return (
          <PopoverButton
            content={
              <div style={{ whiteSpace: "pre-wrap", padding: "1" }}>
                {Object.values(params.value).map((tp) => `${tp}`)}
              </div>
            }
            buttonText={"Ver más"}
          />
        );
      },
    },
    {
      field: "estado",
      headerName: "ESTADO",
      type: "string",
      flex: 1,
      disableColumnMenu: true,
      sortable: false,
      valueGetter: (params) =>
        params.value != null
          ? params.value === "A"
            ? "Activa"
            : "Inactiva"
          : "No aplica",
    },
  ];

  const newModalField = [
    {
      name: "fecha_creacion",
      label: "Fecha de Creación",
      type: "date",
    },
    { name: "codigo", label: "Código", type: "text" },
    { name: "descripcion", label: "Nombre de la subserie", type: "text" },
    {
      name: "id_gd_series",
      label: "Serie",
      type: "select",
      options: listSeries,
    },
    {
      name: "tiempo_archivo_gestion",
      label: "Tiempo Archivo Gestión (Años)",
      type: "text",
    },
    {
      name: "tiempo_archivo_central",
      label: "Tiempo Archivo Central (Años)",
      type: "text",
    },
    {
      name: "id_gd_disposicion_final",
      label: "Disposición Final",
      type: "select",
      options: listDisposicionFinal,
    },
    { name: "procedimiento", label: "Procedimiento", type: "text" },
    {
      name: "id_gd_tipo_soporte",
      label: "Tipo de Soporte",
      type: "select",
      options: listTipoSoporte,
    },
  ];

  const requiredFields = [
    "codigo",
    "descripcion",
    "id_gd_series",
    "tiempo_archivo_gestion",
    "tiempo_archivo_central",
    "id_gd_disposicion_final",
    "procedimiento",
    "id_gd_tipo_soporte",
  ];

  const loadSeries = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + "series/listar?estado=A", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listaserie = data.results.map((serie) => {
          return { value: serie.id_gd_series, label: serie.descripcion };
        });
        setListSeries(listaserie);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  const loadTipoSoporte = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "tipo-soporte/listar?estado=A",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listaTipoSoporte = data.map((tipoSoporte) => {
          return {
            value: tipoSoporte.id_gd_tipo_soporte,
            label: tipoSoporte.descripcion,
          };
        });
        setListTipoSoportes(listaTipoSoporte);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  const loadDisposicionFinal = async () => {
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "disposicion-final/listar?estado=A",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        const listaDisposicionFinal = data.map((disposicionFinal) => {
          return {
            value: disposicionFinal.id_gd_disposicion_final,
            label: disposicionFinal.descripcion,
          };
        });
        setDisposicionFinal(listaDisposicionFinal);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const loadSubseries = async () => {
    await fetch(process.env.REACT_APP_PUBLIC_URL + `subseries/listar?page=${page + 1}&page_size=${pageSize}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + sessionStorage.getItem("token"),
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setSubseries(data.results);
        setRowCount(data.count);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  async function handleSaveNewSerie(formData) {
    let usuario = JSON.parse(sessionStorage.getItem("usuario"));
    let datos = {
      ...formData,
      id_usuario: usuario.id_usuario,
    };
    try {
      const updateResponse = await fetch(
        process.env.REACT_APP_PUBLIC_URL + "subseries/create",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
          body: JSON.stringify(datos),
        }
      );
      const result = await updateResponse.json();
      loadSubseries();
      showModalAlert("success", "Se creo correctamente la subserie");
    } catch (error) {
      showModalAlert("danger", "Error al crear la subserie");
    }
  }

  const onActivate = async (row) => {
    try {
      let usuario = JSON.parse(sessionStorage.getItem("usuario"));
      let dataSend = {
        id_gd_subseries: row.id_gd_subseries,
        id_usuario: usuario.id_usuario,
      };
      await fetch(process.env.REACT_APP_PUBLIC_URL + "subseries/activar", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      });
      loadSubseries();
      showModalAlert("success", "Se activo correctamente la subserie");
    } catch (error) {
      showModalAlert("danger", "Error al activar la subserie");
    }
  };
  const onInactivate = async (row) => {
    try {
      let usuario = JSON.parse(sessionStorage.getItem("usuario"));
      let dataSend = {
        id_gd_subseries: row.id_gd_subseries,
        id_usuario: usuario.id_usuario,
      };
      await fetch(process.env.REACT_APP_PUBLIC_URL + "subseries/inactivar", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      });
      loadSubseries();
      showModalAlert("success", "Se inactivo correctamente la subserie");
    } catch (error) {
      showModalAlert("danger", "Error al inactivar la subserie");
    }
  };

  return (
    <>
      <GeneralTable
        title="Subseries Documentales"
        titleAlert="Subserie Documental"
        buttonText="Crear Subserie"
        columns={columns}
        rows={subseries}
        modalFields={newModalField}
        initialFormData={{
          codigo: "",
          descripcion: "",
          fecha_creacion: moment(),
        }}
        onSaveModal={handleSaveNewSerie}
        onActivate={onActivate}
        onInactivate={onInactivate}
        enableActivate
        //onUpdate={onUpdate}
        enableUpdate={false}
        enableDocumentarytype={false}
        enableView={false}
        loadList={loadSubseries}
        requiredFields={requiredFields}
        rowCount={rowCount}
        pageSize={pageSize}
        page={page}
        handlePageChange={handlePageChange}
        handlePageSizeChange={handlePageSizeChange}
      />
    </>
  );
}
